import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/plus-icon.svg'
import _imports_1 from '@/assets/icons/text-type-icon.svg'
import _imports_2 from '@/assets/icons/chevron-right-icon.svg'
import _imports_3 from '@/assets/icons/text-icon.svg'
import _imports_4 from '@/assets/icons/task-icon.svg'
import _imports_5 from '@/assets/icons/tv-icon.svg'
import _imports_6 from '@/assets/icons/image-icon.svg'
import _imports_7 from '@/assets/icons/youtube-icon.svg'
import _imports_8 from '@/assets/icons/file-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-96da35c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-menu" }
const _hoisted_2 = { class: "li" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nested-dropdowns__item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "15"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nested-dropdowns__item menu-wrapper" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "type ps-2 pt-1" }, "Type")
], -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"nested-dropdowns__item\" data-v-96da35c4><div class=\"item-wrapper d-flex justify-content-between\" data-v-96da35c4><div class=\"d-flex\" data-v-96da35c4><img src=\"" + _imports_1 + "\" class=\"me-2\" alt=\"text-type\" data-v-96da35c4><span data-v-96da35c4>Text</span></div><div class=\"d-flex align-items-center\" data-v-96da35c4><img src=\"" + _imports_2 + "\" alt=\"chevron-right\" data-v-96da35c4></div></div></div>", 1)
const _hoisted_7 = { class: "nested-items" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nested-dropdowns__item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item-wrapper d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_3,
        class: "me-2",
        alt: "simple-task"
      }),
      /*#__PURE__*/_createElementVNode("span", null, "Text")
    ])
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"nested-dropdowns__item\" data-v-96da35c4><div class=\"item-wrapper d-flex justify-content-between\" data-v-96da35c4><div class=\"d-flex\" data-v-96da35c4><img src=\"" + _imports_4 + "\" class=\"me-2\" alt=\"task\" data-v-96da35c4><span data-v-96da35c4>Task</span></div><div class=\"d-flex align-items-center\" data-v-96da35c4><img src=\"" + _imports_2 + "\" alt=\"chevron-right\" data-v-96da35c4></div></div></div>", 1)
const _hoisted_11 = { class: "nested-items" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"nested-dropdowns__item\" data-v-96da35c4><div class=\"item-wrapper d-flex justify-content-between\" data-v-96da35c4><div class=\"d-flex\" data-v-96da35c4><img src=\"" + _imports_5 + "\" class=\"me-2\" alt=\"media\" data-v-96da35c4><span data-v-96da35c4>Media</span></div><div class=\"d-flex align-items-center\" data-v-96da35c4><img src=\"" + _imports_2 + "\" alt=\"chevron-right\" data-v-96da35c4></div></div></div>", 1)
const _hoisted_14 = { class: "nested-items" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nested-dropdowns__item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_6,
        class: "me-2",
        alt: "image"
      }),
      /*#__PURE__*/_createElementVNode("span", null, "Image")
    ])
  ])
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "nested-dropdowns__item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "me-2",
    alt: "youtube"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Youtube")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nested-dropdowns__item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_8,
        class: "me-2",
        alt: "pdf-file"
      }),
      /*#__PURE__*/_createElementVNode("span", null, "PDF")
    ])
  ])
], -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "nested-dropdowns",
      onMouseenter: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onMouseEnter($event, 'main'))),
      onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onMouseLeave($event, 'main')))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", null, [
          _hoisted_5,
          _createElementVNode("li", {
            onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearTimeoutAndReset($event, 'text', ['task', 'media']))),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMouseLeave($event, 'text'))),
            id: "text"
          }, [
            _hoisted_6,
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('addBlock', { type: 'text' }); _ctx.isActive = false;})
              }, _hoisted_9)
            ])
          ], 32),
          _createElementVNode("li", {
            onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearTimeoutAndReset($event, 'task', ['text', 'media']))),
            onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onMouseLeave($event, 'task'))),
            id: "task"
          }, [
            _hoisted_10,
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  class: "item-wrapper",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$emit('addTask', { type: 'task', reference: true }); _ctx.isActive = false;})
                }, " [Add a task] ")
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: task.taskId
                }, [
                  _createElementVNode("div", {
                    class: "item-wrapper",
                    onClick: ($event: any) => {_ctx.$emit('addBlock', { type: 'taskLink', content: { taskId: task.taskId } }); _ctx.isActive = false;}
                  }, _toDisplayString(task.headline), 9, _hoisted_12)
                ]))
              }), 128))
            ])
          ], 32),
          _createElementVNode("li", {
            onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearTimeoutAndReset($event, 'media', ['task', 'text']))),
            onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onMouseLeave($event, 'media'))),
            id: "media"
          }, [
            _hoisted_13,
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.openFilestack('image', 4); _ctx.$emit('tmpBlock', { type: 'image' });})
              }, _hoisted_16),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "item-wrapper",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#videoUrlModal",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$emit('tmpBlock', { type: 'video', }); _ctx.isActive = false;})
                  }, _hoisted_19)
                ])
              ]),
              _createElementVNode("li", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.openFilestack('pdf'); _ctx.$emit('tmpBlock', { type: 'pdf' });})
              }, _hoisted_21)
            ])
          ], 32)
        ])
      ])
    ], 32)
  ]))
}